// extracted by mini-css-extract-plugin
module.exports = {"wishlistWrapper":"Wishlist_wishlistWrapper__2i5AT","fullWidth":"Wishlist_fullWidth__SGtiC","hidden":"Wishlist_hidden__YuiWm"};